export default "__VITE_ASSET__icibL6KnJSP7tMpehf2TGg__";